'use client';

import type { IconButtonProps } from '@mui/material/IconButton';

import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { useSettingsContext } from '../../settings/context';
import { Iconify } from '@/components/common/iconify';

// ----------------------------------------------------------------------

export type SettingsButtonProps = IconButtonProps;

export function SettingsButton({ sx, ...other }: SettingsButtonProps) {
  const settings = useSettingsContext();

  return (
    <Tooltip title="Settings">
      <IconButton
        aria-label="settings"
        onClick={settings.onToggleDrawer}
        sx={{ p: 0, width: 40, height: 40, ...sx }}
        {...other}
      >
        <Badge color="error" variant="dot" invisible={!settings.canReset}>
          <Iconify
            icon="solar:settings-bold"
            width={20}
            sx={{
              color: 'text.primary',
              opacity: 0.7,
              animation: 'spin 8s linear infinite',
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
